export default __webpack_public_path__ + "static/media/portfolio-midios-5.17b3a98f.png";